import type { ReactNode } from "react";

/**
 * Cartão de indicador e moldura de bloco.
 *
 * O tom (`bom`/`atencao`/`ruim`) vem de `leitura.js` e vira só uma classe: cor é
 * decisão de leitura de dado, não de CSS, e por isso é testada lá e não aqui.
 *
 * A cor nunca é o único sinal — cada tom leva também um traço na lateral e, no
 * caso do alerta, um símbolo. Oito por cento dos homens não distinguem verde de
 * vermelho, e um painel de diretoria que só fala por cor exclui uma pessoa em
 * cada doze na sala.
 */

export type Indicador = {
  chave: string;
  rotulo: string;
  valor: string;
  nota: string | null;
  tom: string;
  alerta?: boolean;
};

export function Cartao({ i }: { i: Indicador }) {
  return (
    <article className={`cartao tom-${i.tom}`}>
      <h3>{i.rotulo}</h3>
      <p className="valor">{i.valor}</p>
      {i.nota && (
        <p className="nota">
          {i.alerta && <span className="sinal" aria-hidden="true">▲ </span>}
          {i.nota}
        </p>
      )}
    </article>
  );
}

export function Bloco({
  titulo, subtitulo, largo = false, children,
}: {
  titulo: string; subtitulo?: string; largo?: boolean; children: ReactNode;
}) {
  return (
    <section className={`bloco${largo ? " largo" : ""}`}>
      <header>
        <h2>{titulo}</h2>
        {subtitulo && <p>{subtitulo}</p>}
      </header>
      {children}
    </section>
  );
}

/** Vazio explícito. "Nenhum item em ruptura" é informação; um quadro em branco não. */
export function Vazio({ children }: { children: ReactNode }) {
  return <p className="vazio">{children}</p>;
}
